export default __webpack_public_path__ + "static/media/X_wdt_c_cap_0.9cc881a3.mp3";